<template>
  <div v-bind="$attrs">
    <div
      v-html="$attrs.content"
    />
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
};
</script>

<style>
.privacy-policy-content a {
  color: #000089;
}

.privacy-policy-content h1 {
  font-size: 1.3em;
}

.privacy-policy-content h2 {
  font-size: 1em;
}

.privacy-policy-content h3 {
  font-size: .81em;
}

.privacy-policy-content ol {
  list-style-type: decimal;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
  padding-left: 1em;
}

.privacy-policy-content p {
  padding: 1em 0;
}

.privacy-policy-link {
  color: #000089;
}

@responsive {
  .md-privacy-policy-content {
    height: 75vh;
    width: 50vw;
  }
}
</style>
